import type React from 'react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/cn'

type TruncatedTextWithTooltipProps = {
  children: React.ReactNode
  tooltip?: string
  className?: string
}

export const TruncatedTextWithTooltip: React.FC<
  TruncatedTextWithTooltipProps
> = ({ children, tooltip, className }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={cn('truncate max-w-full', className)}>{children}</div>
        </TooltipTrigger>
        {tooltip && (
          <TooltipContent className="max-w-xs whitespace-normal break-words">
            {tooltip}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  )
}
